import { baseApi } from 'src/Services/api'

export interface Setting {
  id: number
  name: string
  value: string | Array<string> | number
  type: SettingType
  description?: string
  createdAt: string
}

export enum SettingType {
  FLOAT = 'FLOAT',
  JSON = 'JSON',
  NUMBER = 'NUMBER',
  STRING = 'STRING',
  BOOLEAN = 'BOOLEAN',
  ARRAY = 'ARRAY',
  ARRAY_OF_STRINGS = 'ARRAY_OF_STRINGS',
  DATE = 'DATE',
  ARRAY_OF_NUMBERS = 'ARRAY_OF_NUMBERS',
}

export interface AddSettingBody {
  name: string
  value: string
  type: SettingType
  description?: string
}

export const settingsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllSettings: builder.query<Setting[], void>({
      query: () => `/settings`,
      providesTags: ['settings'],
    }),
    updateSetting: builder.mutation<
      Setting,
      {
        name: string
        value: string | Array<string> | number
        type?: SettingType
        description?: string
      }
    >({
      query: ({ name, ...body }) => ({
        url: `/settings/${name}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['settings'],
    }),
  }),
  overrideExisting: true,
})

export const { useGetAllSettingsQuery, useUpdateSettingMutation } = settingsApi
